export default {"src":"/_next/static/media/excel-file.f38620ed.svg","height":50,"width":36,"blurWidth":0,"blurHeight":0};